const tooltipContent = {
  excellent:
    'Based on our analysis of your credit profile, there’s a very high likelihood that you would be approved for this card and receive special offers. Remember that approval is not guaranteed, as the card issuer will make the final decision.',
  good:
    'Based on our analysis of your credit profile, it’s likely that you would be approved for this card. Remember that approval is not guaranteed, as the card issuer will make the final decision.',
  fair:
    'Based on our analysis of your credit profile, there’s a fair chance that you would be approved for this card. While applying may be a bit risky, the card issuer will make the final decision regarding your approval status.',
  poor:
    'Based on our analysis of your credit profile, it’s unlikely that you would be approved for this card. While applying may be risky, the card issuer will make the final decision regarding your approval status.'
}

const aoColorClasses = {
  excellent: 'app-odds-result-btn__bg-green',
  good: 'app-odds-result-btn__bg-green',
  fair: 'app-odds-result-btn__bg-yellow',
  poor: 'app-odds-result-btn__bg-red'
}

module.exports = { tooltipContent, aoColorClasses }
